import { get } from '@api/request';

export async function fetchRollCorrections(
    { appraisalService },
    authenticationToken,
    { pYear },
  ) {
    let url = `${appraisalService}/appraisal/year/${pYear}/rollcorrections`;
    const { body } = await get(authenticationToken, url);
    return body;
  }